import { useState, useEffect } from "react";
import API from "../api";
import CreateOrderModal from "../components/CreateOrderModal";
import InventorySidebar from "../components/InventorySidebar";

function Orders() {

  const [orders, setOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showInventory, setShowInventory] = useState(false);

  const [customerFilter, setCustomerFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [inventoryRefreshKey, setInventoryRefreshKey] = useState(0);

    const refreshInventory = () => {
    setInventoryRefreshKey(prev => prev + 1);
    };

  /* ================= FETCH ORDERS ================= */

  useEffect(() => {
  fetchOrders();
    }, [customerFilter, dateFilter, statusFilter]);

  const fetchOrders = () => {

  let url = "order/order-list/?";

  if (customerFilter) {
    url += `customer=${customerFilter}&`;
  }

  if (dateFilter) {
    url += `date=${dateFilter}&`;
  }

  if (statusFilter) {
    url += `status=${statusFilter}`;
  }

  API.get(url).then(res => setOrders(res.data));
};


  /* ================= UPDATE STATUS ================= */

  const updateStatus = async (itemId, status) => {
    await API.patch(`order/update-order-item-status/${itemId}/`, {
      status: status
    });

    fetchOrders();
  };

  /* ================= RENDER ================= */

  return (
    <div className="container-fluid h-100">

      <div className="row h-100">

        {/* ================= LEFT PANEL (ORDERS) ================= */}

        <div className={showInventory ? "col-md-8 d-flex flex-column h-100" : "col-md-12 d-flex flex-column h-100"}>

          {/* HEADER + FILTERS (FIXED) */}
          <div className="p-3 border-bottom">

            <div className="d-flex justify-content-between align-items-center mb-3">

              <h5 className="mb-0">Orders</h5>

              <div className="d-flex gap-2">

                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setShowInventory(!showInventory)}
                >
                  <i className="bi bi-box-seam me-1"></i>
                  {showInventory ? "Hide Inventory" : "Show Inventory"}
                </button>

                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => setShowModal(true)}
                >
                  <i className="bi bi-plus-lg me-1"></i>
                  New Order
                </button>

              </div>
            </div>

            {/* FILTER BAR */}

            <div className="row g-2">

              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Filter by customer..."
                  value={customerFilter}
                  onChange={e => setCustomerFilter(e.target.value)}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={dateFilter}
                  onChange={e => setDateFilter(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <select
                    className="form-select form-select-sm"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="">All Status</option>
                    <option value="PENDING">Pending</option>
                    <option value="DONE">Done</option>
                    <option value="DELIVERED">Delivered</option>
                </select>
                </div>

              <div className="col-md-2">
                <button
                  className="btn btn-sm btn-outline-secondary w-100"
                  onClick={() => {
                    setCustomerFilter("");
                    setDateFilter("");
                    setStatusFilter("");
                    }}
                >
                  Clear
                </button>
              </div>

            </div>

          </div>

          {/* ================= SCROLLABLE ORDER LIST ================= */}

          <div style={{ flex: 1, overflowY: "auto" }}>

            <div className="p-3">

              {orders.length === 0 && (
                <div className="text-center text-muted p-3">
                  No orders found
                </div>
              )}

              {orders.map((group, index) => (
                <div key={index} className="card mb-3 border">

                  {/* GROUP HEADER */}
                  <div className="card-header py-2 d-flex justify-content-between align-items-center bg-light">

                    <div>
                      <strong>{group.customer_name}</strong>
                      <span className="text-muted ms-2 small">
                        {group.order_date}
                      </span>
                    </div>

                    <span className="badge bg-secondary">
                       Total Sheets: {group.items.reduce((total, item) => total + parseInt(item.quantity), 0)}
                    </span>

                  </div>

                  {/* ITEMS TABLE */}
                  <div className="card-body p-0">

                    <table className="table table-sm mb-0">
                      <thead className="table-light">
                        <tr>
                            <th className="ps-3">Sheet</th>
                            <th width="70">Qty</th>
                            <th>Strips</th>
                            <th width="200">Status</th>
                        </tr>
                        </thead>

                      <tbody>
                        {group.items.map((item, i) => (
                          <tr key={i}>

                            <td className="ps-3">{item.sheet_name}</td>

                            <td>{item.quantity}</td>

                            <td>
                              {item.strips.map(s => (
                                <span
                                  key={s}
                                  className="badge bg-info text-dark me-1"
                                >
                                  {s}
                                </span>
                              ))}
                            </td>

                            <td>
                              <div className="d-flex align-items-center gap-2">

                                <select
                                className="form-select form-select-sm"
                                style={{
                                    width: "120px",
                                    backgroundColor:
                                    item.status === "PENDING"
                                        ? "#ffc107"
                                        : item.status === "DONE"
                                        ? "#0d6efd"
                                        : "#198754",
                                    color: item.status === "PENDING" ? "#000" : "#fff",
                                }}
                                value={item.status}
                                onChange={(e) =>
                                    updateStatus(item.item_id, e.target.value)
                                }
                                >
                                <option value="PENDING">Pending</option>
                                <option value="DONE">Done</option>
                                <option value="DELIVERED">Delivered</option>
                                </select>
                              </div>
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>

                  </div>

                </div>
              ))}

            </div>
          </div>

        </div>

        {/* ================= RIGHT PANEL (INVENTORY) ================= */}

        {showInventory && (
          <div className="col-md-4 d-flex flex-column h-100 border-start">

            <div style={{ flex: 1, overflowY: "auto" }}>
              <div className="p-3">
                <InventorySidebar key={inventoryRefreshKey}/>
              </div>
            </div>

          </div>
        )}

      </div>

      {/* ================= MODAL ================= */}

      {showModal && (
        <CreateOrderModal
          onClose={() => setShowModal(false)}
          refreshOrders={fetchOrders}
          refreshInventory={refreshInventory}
        />
      )}

    </div>
  );
}

export default Orders;
